export const SET_USER_PROFILE = 'SET_USER_PROFILE';

export function setUserProfile(data) {
    return function (dispatch) {
        dispatch({ type: SET_USER_PROFILE, userProfile: data });
    };
}